import { Field } from 'formik';
import { useIntl } from 'react-intl';
import { FieldProps } from '../../types/fields';
import { config } from '../../utils/config';
import SelectField from '../formik/SelectField';

type GenderFieldProps = FieldProps & {
  name: string;
};

const GenderField = ({ name, testIdPrefix }: GenderFieldProps) => {
  const { formatMessage } = useIntl();
  const { neutralGender, notSpecifiedGender } = config.features;

  const genderPrefix = 'generic.salutation';
  const genders = ['f', 'm', ...(neutralGender.enabled ? ['d'] : []), ...(notSpecifiedGender.enabled ? ['n'] : [])];
  const options = genders.map(value => ({ label: formatMessage({ id: `${genderPrefix}.options.${value}` }), value }));

  return (
    <Field
      name={name}
      component={SelectField}
      label={formatMessage({ id: 'generic.salutation.label' })}
      options={options}
      data-test-id={`${testIdPrefix}-gender`}
      autoComplete="sex"
    />
  );
};

export default GenderField;
